import { router } from '@inertiajs/svelte'
import type { NavigationMenuKey } from 'frontend/inertia/navigation_menus'

export interface NavLink {
  kind: 'link'
  label: string
  icon: string
  href: string
}

export interface NavTopic {
  label: string
  href: string
}

export interface NavSubjectArea {
  slug: string
  label: string
  icon: string
  badgeClass: string
  startsAdditionalGroup: boolean
  href: string
  topicsOverviewHref: string
  topics: NavTopic[]
}

export interface NavEducationLevel {
  kind: 'educationLevel'
  key: string
  label: string
  shortLabel: string
  icon: string
  href: string
  subjectAreas: NavSubjectArea[]
}

export type Level1Item = NavLink | NavEducationLevel

export function isEducationLevel(item: Level1Item): item is NavEducationLevel {
  return item.kind === 'educationLevel'
}

export type NavigationMenus = Partial<Record<NavigationMenuKey, Level1Item[]>>

interface NavigationStore {
  ready: boolean
  menus: NavigationMenus
}

export const navigation = $state<NavigationStore>({ ready: false, menus: {} })

export function navigationItems(menuKeys: NavigationMenuKey[]): Level1Item[] {
  return menuKeys.flatMap((key) => navigation.menus[key] ?? [])
}

export interface SerializedNavigationData {
  menus: NavigationMenus
}

let loading = false

export function resetNavigation(): void {
  navigation.ready = false
}

export function loadNavigation(): void {
  if (import.meta.env.SSR) return
  if (navigation.ready || loading) return

  loading = true
  router.reload({
    only: ['navigation'],
    onSuccess: (page) => {
      const data = page.props.navigation
      if (!data) return
      navigation.menus = data.menus ?? {}
      navigation.ready = true
    },
    onFinish: () => {
      loading = false
    },
  })
}
